import { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

const RibuInput = ({ ribos, reiksmes, changeReiksmes }) => {
  const [minError, setMinError] = useState("");
  const [maxError, setMaxError] = useState("");

  const [inputValues, setInputValues] = useState({
    min: String(reiksmes.min),
    max: String(reiksmes.max),
  });

  useEffect(() => {
    setInputValues({
      min: String(reiksmes.min),
      max: String(reiksmes.max),
    });
  }, [reiksmes.min, reiksmes.max]); // Explicit dependency on min and max

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValues((prev) => ({ ...prev, [name]: value }));

    if (value === "") {
      if (name === "min") {
        setMinError(`Reikšmė negali būti tuščia. Minimali reikšmė: ${ribos.ribos.min}`);
      } else {
        setMaxError(`Reikšmė negali būti tuščia. Maksimali reikšmė: ${ribos.ribos.max}`);
      }
      return; // Don't update parent when empty
    }

    const numericValue = Number(value);
    let isValid = true;

    if (name === "min" && numericValue < ribos.ribos.min) {
      setMinError(`Įvesta per maža reikšmė, minimalus skaičius: ${ribos.ribos.min}`);
      isValid = false;
    } else if (name === "min") {
      setMinError("");
    }

    if (name === "max" && numericValue > ribos.ribos.max) {
      setMaxError(`Įvesta per didelė reikšmė, maksimalus skaičius: ${ribos.ribos.max}`);
      isValid = false;
    } else if (name === "max") {
      setMaxError("");
    }

    if (isValid) {
      const otherFieldName = name === "min" ? "max" : "min";
      const otherValue = inputValues[otherFieldName];

      changeReiksmes({
        ...reiksmes,
        [name]: numericValue,
        [otherFieldName]: Number(otherValue),
      });
    }
  };

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography noWrap>{ribos.pavadinimas}</Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "8px",
            width: "100%",
          }}
        >
          <Box width="50%">
            <TextField
              id="min"
              name="min"
              type="number"
              variant="outlined"
              value={inputValues.min}
              size="small"
              fullWidth
              error={minError !== ""}
              onChange={handleChange}
              title={minError || undefined}
              helperText={minError ? " " : undefined} // Add space to reserve layout height
              sx={{
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                  display: "none",
                },
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
                "& .MuiFormHelperText-root": {
                  margin: 0,
                  height: "0px",
                },
              }}
            />
          </Box>
          <Box width="50%">
            <TextField
              id="max"
              name="max"
              type="number"
              variant="outlined"
              size="small"
              value={inputValues.max}
              fullWidth
              title={maxError || undefined}
              error={maxError !== ""}
              helperText={maxError ? " " : undefined}
              onChange={handleChange}
              sx={{
                "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
                  display: "none",
                },
                "& input[type=number]": {
                  MozAppearance: "textfield",
                },
                "& .MuiFormHelperText-root": {
                  margin: 0,
                  height: "0px",
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default RibuInput;
